import { createSelector } from 'reselect';

const selectSupportVpn = () => (state) => state.get('supportVpn');

const makeSelectSupportVpn = () =>
  createSelector(selectSupportVpn(), (substate) => substate);

export { makeSelectSupportVpn };
